var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLeaderboardsIcon = function SvgLeaderboardsIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "menu-item-icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.967,
    height: 20.101
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 108515",
    d: "m.12 6.756 10.09 12.53-4.577-12.53H.12",
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 108516",
    d: "m6.533 6.756 4.877 13.345 4.972-13.345H6.533",
    fillRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 108517",
    d: "M12.495 19.604 22.846 6.755h-5.563l-4.787 12.849",
    fillRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 108518",
    d: "M18.898 0H12.37l4.475 5.508L18.897 0",
    fillRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 108519",
    d: "m16.085 5.912-4.6-5.664-4.6 5.664h9.2",
    fillRule: "evenodd"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 108520",
    d: "M10.596 0H4.064L6.09 5.545 10.595 0",
    fillRule: "evenodd"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 108521",
    d: "M3.36.535 0 5.912h5.325L3.36.535",
    fillRule: "evenodd"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 108522",
    d: "M22.967 5.912 19.603.529l-2.005 5.383h5.369",
    fillRule: "evenodd"
  })));
};
export default SvgLeaderboardsIcon;